import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TabBar.css';
class TabBar extends Component {
  static propTypes = {
    tabContentMetadata: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        onClick: PropTypes.func
      })
    ),
    activeTabId: PropTypes.string
  };

  render() {
    const { tabContentMetadata = [], activeTabId } = this.props;

    return (
      <div className="tabBarComponent">
        {tabContentMetadata.map(tab => (
          <div
            className={`tabBarButton ${tab.id === activeTabId ? 'active' : ''}`}
            key={tab.id}
            onClick={() => {
              tab.onClick && tab.onClick();
            }}>
            {tab.title}
          </div>
        ))}
      </div>
    );
  }
}

export default TabBar;



// WEBPACK FOOTER //
// ./src/Components/TabBar/TabBar.js